export const newRequest = ({
  descriptionUrl = 'https://pluto.tv',
  continuousPlayback = false,
  videoHeight,
  videoWidth,
}) => {
  const request = new global.window.goog.pal.NonceRequest();
  request.adWillAutoPlay = true;
  request.adWillPlayMuted = true;
  request.continuousPlayback = continuousPlayback;
  request.descriptionUrl = descriptionUrl;
  request.iconsSupported = false;
  request.playerType = 'clappr';
  request.playerVersion = 'fd4c68a';
  request.videoHeight = videoHeight;
  request.videoWidth = videoWidth;
  return request;
};

export const getNonce = async (request) => {
  const nonceLoader = new global.window.goog.pal.NonceLoader();
  const nonce = await nonceLoader.loadNonceManager(request);
  return nonce;
};
